import React from "react"
import "./about.css"
import Me from "../../assets/me_about_2.jpeg"
import {RiAwardLine} from "react-icons/ri"
import {AiOutlineLaptop} from "react-icons/ai"

const About = () => {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        {/* <div className="about__me"> */}
          <div className="about__me-image">
            <img src={Me} alt="About" />
          </div>
        {/* </div> */}

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <RiAwardLine className="about__icon" />
              <h5>Experience</h5>
              <small>1+ Years Working in Internships</small>
            </article>

            <article className="about__card">
              <AiOutlineLaptop className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>

          <p>
            I am a college senior currently pursuing a degree in Computer Science from BITS-Pilani, Goa.
            I have a background in Web Development and Android Development. In the past, I have interned as a Web Development Intern at Seekify Technologies, and as an SDE Intern at IBM India.
            I am also an upcoming Software Development Engineer (SDE-1) at Amazon.
          </p>
          <p>
            I strive hard each day to learn something new, and acquire a new value everyday. 
            I am a passionate person with a target-driven mindset, and I focus on completing the task given with the maximum efficiency and accuracy.
          </p>
          <p>
            Recently, I have been actively exploring the field of Data Analysis and Cybersecurity.
            Apart from my academic and development interests, my hobbies include reading books, playing Badminton and gaming.
          </p>

          <a href="#contact" className="btn btn-primary">Let's Get in Touch</a>
        </div>
      </div>
    </section>
  )
}

export default About;